class AppContextInstance {
    _properties = {};
    _providers = {};
    _resolvers = {};
    _rejectors = {};
    _getOrCreateResolution(name) {
        if (!this._providers[name]) {
            this._providers[name] = new Promise((resolve, reject) => {
                this._resolvers[name] = resolve;
                this._rejectors[name] = reject;
            });
        }
        return this._providers[name];
    }
    get(name) {
        if (typeof this._properties[name] === 'undefined')
            throw new Error(`${name} is not yet set`);
        return this._properties[name];
    }
    set(name, value) {
        this._properties[name] = value;
    }
    require(name) {
        return this._getOrCreateResolution(name);
    }
    provide(name, value) {
        void this._getOrCreateResolution(name);
        this._resolvers[name](value);
    }
    waitUntil(name) {
        return this._getOrCreateResolution('$_DEFER_' + name);
    }
    _release(name) {
        const lock = '$_DEFER_' + name;
        delete this._providers[lock];
        delete this._resolvers[lock];
        delete this._rejectors[lock];
    }
    allow(name, value) {
        const lock = '$_DEFER_' + name;
        void this._getOrCreateResolution(lock).finally(() => this._release(lock));
        this._resolvers[lock](value);
    }
    block(name, reason) {
        const lock = '$_DEFER_' + name;
        void this._getOrCreateResolution(lock).finally(() => this._release(lock));
        this._rejectors[lock](reason);
    }
}
/**
 * @singleton
 */
export const AppContext = new AppContextInstance();
// @ts-ignore
(typeof window !== 'undefined') ? window.AppContext = AppContext : void 0;
//# sourceMappingURL=AppContext.js.map